<template>
  <div class="questionare-text bold big">
    <input ref="input" class="invisible-input questionare-text bold big p-0 w-100"
           style="text-align: left!important; max-width: 100%!important;"
           type="text" :value="displayValue"
           @input="handleOnInput" @click="removeZero" @focusout="unshiftZero" inputmode="numeric">
  </div>
</template>

<script>
export default {
  name: "InvisibleInput",
  props: {
    value: {String, Number},
    type: {type: String, default: "text"},
    max: Number,
    min: Number,
    after: String
  },
  data() {
    return {
      isMobile: false,
      focused: false,
    }
  },
  methods: {
    removeZero() {
      this.focused = true;

      const input = this.$refs.input;

      if (input.value.charAt(0) === "0" || input.value.charAt(0) === "N") {
        input.value = ` ${this.after}`;
        input.setSelectionRange(0, 0);
      } else {
        input.setSelectionRange(input.value.length - 4, input.value.length - 4);
      }
    },
    unshiftZero() {
      this.focused = false;

      const input = this.$refs.input;

      if (input.value.charAt(0) === this.after.charAt(0))
        this.$refs.input.value = (0).toString() + this.after;
    },
    verifyMax(e, value) {
      let valueChanged = false;

      if (value > this.max) {
        e.target.value = this.max;
        valueChanged = true;
      } else if (!value || value < this.min) {
        e.target.value = this.min;
        valueChanged = true;
      }

      if (valueChanged)
        this.handleOnInput(e, true);
    },
    handleOnInput(e, verified = false) {
      this.$forceUpdate();

      let value = e.target.value;

      if (this.type === 'number') {
        const numbers = value.match(/\d+/g);
        value = Number(numbers);
      }

      if (!verified)
        this.verifyMax(e, value);

      if (typeof value === 'number') {
        this.$emit('input', value);
      }
    }
  },
  computed: {
    displayValue() {
      if(!this.value && this.focused)
        return " EUR";

      return `${Math.round(this.value)} EUR`;
    }
  },
  watch: {
    value(to) {
      if (!to)
        this.removeZero();
    }
  }
};
</script>

<style lang="scss" scoped>
.invisible-input {
  background: transparent;
  max-width: none !important;
  border: none;
  outline: none !important;

  &::after {
    content: "EUR";
  }
}

.invisible-input::-webkit-outer-spin-button,
.invisible-input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
.invisible-input[type=number] {
  -moz-appearance: textfield;
}
</style>
